import { render, staticRenderFns } from "./editProduct.vue?vue&type=template&id=05c0c624&"
import script from "./editProduct.vue?vue&type=script&lang=js&"
export * from "./editProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports